import { genericCallWithBody, genericGetWithParameters } from "./Networking";

export async function getListOfSettlementsForCustomer(customerID, currencyID, orderNo, withAvailableBalance, showFullyApplied, fundsFlow, page, items){
    try {
        let params = {
            'CustomerID': customerID,
            'CurrencyID': currencyID,
            'BNOrderNo': orderNo,
            'WithAvailableBalance': withAvailableBalance,
            'ShowFullyApplied': showFullyApplied,
            'FundsFlow': fundsFlow,
            'Page': page,
            'Items': items
        }

        let response = await genericGetWithParameters('Settlement/GetListOfSettlementsForCustomer',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveSettlements(model){
    let response = await genericCallWithBody('POST','Settlement/SaveSettlements',model);
    return response;
}

export async function getSettlement(id){
    try {
        let params = {
            'settlementId': id
        }

        let response = await genericGetWithParameters('Settlement/GetBNSettlements',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function getSettlementsWithBalanceByCustomerCurrency(CustomerID, CurrencyID, FundsFlow){
    try {
        let params = {
            'CustomerID': CustomerID,
            'CurrencyID': CurrencyID,
            'FundsFlow' : FundsFlow
        }
        
        let response = await genericGetWithParameters('Settlement/GetSettlementsWithBalanceByCustomerCurrency',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function applySettlement(model) {
    var method = 'POST';
    var apiName = 'Settlement/ApplySettlement'
    let response = await genericCallWithBody(method, apiName, model);
    return response;
}

export async function unapplySettlement(model) {
    var method = 'POST';
    var apiName = 'Settlement/UnapplySettlement'
    let response = await genericCallWithBody(method, apiName, model);
    return response;
}

export async function voidSettlement(model) {
    var method = 'POST';
    var apiName = 'Settlement/VoidSettlement'
    let response = await genericCallWithBody(method, apiName, model);
    return response;
}